var e = { exports: {} };
export {
  e as __module
};
//# sourceMappingURL=index.es295.js.map
